<template>
  <v-app id="inspire">
    <nav class="lp-nav" :class="{ 'lp-nav--scrolled': scrolled }">
      <div class="lp-container lp-nav__inner">
        <a class="lp-nav__brand" href="#" @click.prevent="scrollToTop">
          <img src="../assets/urbanGo.png" class="lp-nav__logo" alt="urbanGo" />
        </a>

        <div class="lp-nav__links">
          <a class="lp-nav__link" href="#fonctionnalites">Fonctionnalités</a>
          <a class="lp-nav__link" href="#demarrage">Démarrage</a>
          <a class="lp-nav__link" href="#contact">Contact</a>
          <button class="lp-btn lp-btn--ghost" @click="goToLoginPage">Connexion</button>
          <button class="lp-btn lp-btn--primary" @click="goToAdhesionPage">Inscrire ma compagnie</button>
        </div>

        <button class="lp-nav__toggle" @click="mobileMenuOpen = !mobileMenuOpen">
          {{ mobileMenuOpen ? "Fermer" : "Menu" }}
        </button>
      </div>

      <transition name="lp-drop">
        <div v-if="mobileMenuOpen" class="lp-nav__mobile">
          <a class="lp-nav__mobile-link" href="#fonctionnalites" @click="mobileMenuOpen = false">Fonctionnalités</a>
          <a class="lp-nav__mobile-link" href="#demarrage" @click="mobileMenuOpen = false">Démarrage</a>
          <a class="lp-nav__mobile-link" href="#contact" @click="mobileMenuOpen = false">Contact</a>
          <button class="lp-btn lp-btn--ghost lp-btn--block" @click="goToLoginPage">Connexion</button>
          <button class="lp-btn lp-btn--primary lp-btn--block" @click="goToAdhesionPage">Inscrire ma compagnie</button>
        </div>
      </transition>
    </nav>

    <!-- HERO -->
    <section class="lp-hero">
      <div class="lp-hero__glow lp-hero__glow--green"></div>
      <div class="lp-hero__glow lp-hero__glow--navy"></div>
      <div class="lp-hero__grid-bg"></div>

      <div class="lp-container lp-hero__grid">
        <div class="lp-hero__content">
          <div class="lp-pill lp-anim" style="--d: 0s">
            <span class="lp-pill__dot"></span>
            Pour les compagnies de transport
          </div>
          <h1 class="lp-hero__title lp-anim" style="--d: 0.08s">
            Administrez votre compagnie de voyage depuis
            <span class="lp-highlight">un seul espace</span>.
          </h1>
          <p class="lp-hero__text lp-anim" style="--d: 0.16s">
            Publiez vos offres de voyage, organisez vos programmes et vos tarifs, suivez vos
            réservations et vos ventes. urbanGo met à votre disposition un outil de gestion
            simple, pensé pour les transporteurs.
          </p>
          <div class="lp-hero__actions lp-anim" style="--d: 0.24s">
            <button class="lp-btn lp-btn--primary lp-btn--lg" @click="goToAdhesionPage">Inscrire ma compagnie</button>
            <button class="lp-btn lp-btn--outline lp-btn--lg" @click="goToLoginPage">Accéder à mon espace</button>
          </div>
          <div class="lp-hero__meta lp-anim" style="--d: 0.32s">
            <span>Sans installation</span>
            <span class="lp-hero__sep"></span>
            <span>Accessible depuis un navigateur</span>
            <span class="lp-hero__sep"></span>
            <span>Application mobile bientôt</span>
          </div>
        </div>

        <!-- Aperçu de l'espace compagnie -->
        <div class="lp-hero__visual lp-anim" style="--d: 0.2s">
          <div class="lp-preview">
            <div class="lp-preview__bar">
              <span></span><span></span><span></span>
              <div class="lp-preview__url">urbango · espace compagnie</div>
            </div>
            <div class="lp-preview__head">
              <div>
                <div class="lp-preview__label">Offres de voyage</div>
                <div class="lp-preview__title">Cette semaine</div>
              </div>
              <span class="lp-preview__tag">4 actives</span>
            </div>
            <div class="lp-preview__row lp-preview__row--head">
              <span>Trajet</span>
              <span>Départ</span>
              <span>Remplissage</span>
              <span class="lp-right">Tarif</span>
            </div>
            <div v-for="(offre, i) in apercuOffres" :key="i" class="lp-preview__row">
              <span class="lp-preview__trajet">{{ offre.trajet }}</span>
              <span>{{ offre.depart }}</span>
              <span class="lp-preview__fill">
                <span class="lp-preview__track">
                  <span class="lp-preview__bar-fill" :style="{ width: offre.remplissage + '%' }"></span>
                </span>
                <span class="lp-preview__pct">{{ offre.remplissage }}%</span>
              </span>
              <span class="lp-right lp-preview__prix">{{ offre.tarif }}</span>
            </div>
            <div class="lp-preview__foot">
              <div>
                <div class="lp-preview__stat">128</div>
                <div class="lp-preview__stat-label">Réservations</div>
              </div>
              <div>
                <div class="lp-preview__stat">1,9 M</div>
                <div class="lp-preview__stat-label">Ventes (FCFA)</div>
              </div>
              <div>
                <div class="lp-preview__stat">86 %</div>
                <div class="lp-preview__stat-label">Remplissage</div>
              </div>
            </div>
          </div>

          <div class="lp-float lp-float--top">
            <div class="lp-float__label">Nouvelle réservation</div>
            <div class="lp-float__value">Abidjan → Bouaké · 2 places</div>
          </div>
          <div class="lp-float lp-float--bottom">
            <div class="lp-float__label">Ventes du jour</div>
            <div class="lp-float__value lp-float__value--green">+ 245 000 FCFA</div>
          </div>
        </div>
      </div>
    </section>

    <!-- BANDEAU -->
    <section class="lp-strip">
      <div class="lp-container lp-strip__inner">
        <div v-for="(item, i) in bandeau" :key="i" class="lp-strip__item lp-reveal">
          <div class="lp-strip__value">{{ item.valeur }}</div>
          <div class="lp-strip__label">{{ item.label }}</div>
        </div>
      </div>
    </section>

    <!-- FONCTIONNALITÉS -->
    <section class="lp-section" id="fonctionnalites">
      <div class="lp-container">
        <div class="lp-section__head lp-reveal">
          <div class="lp-kicker">Fonctionnalités</div>
          <h2 class="lp-section__title">Tout ce qu'il faut pour <span class="lp-highlight">gérer votre activité</span></h2>
          <p class="lp-section__text">
            Un espace d'administration complet pour piloter votre compagnie au quotidien.
          </p>
        </div>

        <div class="lp-features">
          <div v-for="(f, i) in fonctionnalites" :key="i" class="lp-feature lp-reveal">
            <div class="lp-feature__num">{{ String(i + 1).padStart(2, "0") }}</div>
            <h3 class="lp-feature__title">{{ f.titre }}</h3>
            <p class="lp-feature__text">{{ f.texte }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- DÉMARRAGE -->
    <section class="lp-section lp-section--alt" id="demarrage">
      <div class="lp-container">
        <div class="lp-section__head lp-section__head--center lp-reveal">
          <div class="lp-kicker">Démarrage</div>
          <h2 class="lp-section__title">Rejoignez urbanGo en <span class="lp-highlight">trois étapes</span></h2>
        </div>

        <ol class="lp-steps">
          <li
            v-for="(etape, i) in etapes"
            :key="i"
            class="lp-step lp-reveal"
            :style="{ '--d': i * 0.1 + 's' }"
          >
            <div class="lp-step__num">{{ i + 1 }}</div>
            <h3 class="lp-step__title">{{ etape.titre }}</h3>
            <p class="lp-step__text">{{ etape.texte }}</p>
          </li>
        </ol>
      </div>
    </section>

    <!-- CTA -->
    <section class="lp-cta-wrap" id="contact">
      <div class="lp-container">
        <div class="lp-cta lp-reveal">
          <div class="lp-cta__ring lp-cta__ring--1"></div>
          <div class="lp-cta__ring lp-cta__ring--2"></div>
          <div class="lp-cta__inner">
            <div>
              <h2 class="lp-cta__title">Prêt à digitaliser votre compagnie ?</h2>
              <p class="lp-cta__text">
                Envoyez votre demande d'adhésion ou écrivez-nous à
                <a href="mailto:support@urbanGo.com">support@urbanGo.com</a>.
              </p>
            </div>
            <div class="lp-cta__actions">
              <button class="lp-btn lp-btn--primary lp-btn--lg" @click="goToAdhesionPage">Inscrire ma compagnie</button>
              <button class="lp-btn lp-btn--light lp-btn--lg" @click="goToLoginPage">Se connecter</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FOOTER -->
    <footer class="lp-footer">
      <div class="lp-container">
        <div class="lp-footer__top">
          <div class="lp-footer__about">
            <div class="lp-footer__brand">
              <img src="../assets/urbanGo.png" height="36" width="39" alt="urbanGo" />
              <span>urbanGo</span>
            </div>
            <p class="lp-footer__desc">
              La plateforme de gestion des compagnies de transport de voyageurs.
            </p>
            <a href="#" class="lp-store" @click.prevent title="Application Android bientôt disponible">
              <span class="lp-store__small">Bientôt disponible sur</span>
              <span class="lp-store__name">Google Play</span>
            </a>
          </div>

          <div class="lp-footer__col">
            <div class="lp-footer__title">Navigation</div>
            <a href="#fonctionnalites">Fonctionnalités</a>
            <a href="#demarrage">Démarrage</a>
            <a href="#contact">Contact</a>
          </div>

          <div class="lp-footer__col">
            <div class="lp-footer__title">Compagnies</div>
            <a href="#" @click.prevent="goToAdhesionPage">Inscrire ma compagnie</a>
            <a href="#" @click.prevent="goToLoginPage">Se connecter</a>
            <a href="mailto:support@urbanGo.com">support@urbanGo.com</a>
          </div>

          <div class="lp-footer__col">
            <div class="lp-footer__title">Légal</div>
            <a href="#" @click.prevent="goToPrivacyPolicy">Politique de confidentialité</a>
            <a href="#" @click.prevent="goToTermsAndConditions">Conditions d'utilisation</a>
          </div>
        </div>

        <div class="lp-footer__bottom">
          <span>© {{ currentYear }} urbanGo. Tous droits réservés.</span>
          <span>Conçu en Côte d'Ivoire</span>
        </div>
      </div>
    </footer>
  </v-app>
</template>

<script>
export default {
  name: "LandingVue",

  data() {
    return {
      mobileMenuOpen: false,

      scrolled: false,

      observer: null,

      apercuOffres: [
        { trajet: "Abidjan → Yamoussoukro", depart: "07:30", remplissage: 64, tarif: "5 000 F" },
        { trajet: "Abidjan → Bouaké", depart: "09:00", remplissage: 36, tarif: "7 000 F" },
        { trajet: "Abidjan → San-Pédro", depart: "13:15", remplissage: 82, tarif: "8 000 F" },
        { trajet: "Bouaké → Korhogo", depart: "16:00", remplissage: 24, tarif: "6 000 F" },
      ],

      bandeau: [
        { valeur: "Offres", label: "Trajets publiés en quelques clics" },
        { valeur: "Ventes", label: "Suivies en temps réel" },
        { valeur: "Équipes", label: "Accès par rôle et par gare" },
        { valeur: "Bagages", label: "Enregistrés et tracés" },
      ],

      fonctionnalites: [
        {
          titre: "Offres de voyage",
          texte: "Créez vos offres par trajet, définissez les jours de circulation et ouvrez-les à la réservation.",
        },
        {
          titre: "Programmes & horaires",
          texte: "Planifiez vos départs, affectez vos véhicules et gérez la disponibilité des places.",
        },
        {
          titre: "Tarification",
          texte: "Fixez vos prix par trajet et par catégorie, et ajustez-les à tout moment.",
        },
        {
          titre: "Réservations & ventes",
          texte: "Suivez en temps réel les billets vendus, les réservations et les encaissements.",
        },
        {
          titre: "Gares & personnel",
          texte: "Gérez vos gares, vos agents et leurs accès avec des rôles adaptés.",
        },
        {
          titre: "Bagages & suivi",
          texte: "Enregistrez les bagages des voyageurs et suivez-les jusqu'à destination.",
        },
      ],

      etapes: [
        {
          titre: "Demande d'adhésion",
          texte: "Remplissez le formulaire avec les informations de votre compagnie.",
        },
        {
          titre: "Validation du compte",
          texte: "Notre équipe vérifie votre demande et active votre espace compagnie.",
        },
        {
          titre: "Publication de vos offres",
          texte: "Configurez vos trajets, programmes et tarifs, puis commencez à vendre.",
        },
      ],
    };
  },

  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },

  methods: {
    // GO TO LOGIN PAGE TO GET INTEFACE USER
    goToLoginPage() {
      this.$router.push({ path: "/Login" });
    },

    // GO TO ADHESION PAGE
    goToAdhesionPage() {
      this.$router.push({ path: "/DemandeAdhesion" });
    },

    // GO TO PRIVACY POLICY PAGE
    goToPrivacyPolicy() {
      this.$router.push({ path: "/privacy-policy" });
    },

    // GO TO TERMS AND CONDITIONS PAGE
    goToTermsAndConditions() {
      this.$router.push({ path: "/terms-and-conditions" });
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    onScroll() {
      this.scrolled = window.scrollY > 8;
    },
  },

  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();

    // APPARITION DES BLOCS AU DÉFILEMENT
    const blocs = this.$el.querySelectorAll(".lp-reveal");
    if (!("IntersectionObserver" in window)) {
      blocs.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            this.observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    blocs.forEach((el) => this.observer.observe(el));
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    if (this.observer) this.observer.disconnect();
  },
};
</script>

<style lang="scss" scoped>
$green: #159e72;
$green-dark: #11845f;
$teal: #079992;
$navy: #0c2461;
$navy-deep: #081a47;
$ink: #0f172a;
$muted: #475569;
$line: rgba(15, 23, 42, 0.08);
$soft: #f8fafc;

#inspire {
  background: #ffffff;
  color: $ink;
}

.lp-container {
  position: relative;
  width: 100%;
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 20px;
}

.lp-right {
  text-align: right;
}

.lp-highlight {
  background: linear-gradient(120deg, $green 0%, $teal 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lp-kicker {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: $green;
  margin-bottom: 14px;
}

/* ANIMATIONS */
@keyframes lp-fade-up {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes lp-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

@keyframes lp-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(21, 158, 114, 0.5);
  }
  100% {
    box-shadow: 0 0 0 8px rgba(21, 158, 114, 0);
  }
}

.lp-anim {
  opacity: 0;
  animation: lp-fade-up 0.7s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  animation-delay: var(--d, 0s);
}

.lp-reveal {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1), transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
  transition-delay: var(--d, 0s);

  &.is-visible {
    opacity: 1;
    transform: none;
  }
}

/* BOUTONS */
.lp-btn {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 14px;
  border-radius: 10px;
  padding: 10px 18px;
  border: 1px solid transparent;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &--lg {
    font-size: 15px;
    padding: 15px 26px;
    border-radius: 12px;
  }

  &--block {
    width: 100%;
  }

  &--primary {
    background: linear-gradient(135deg, $green 0%, $green-dark 100%);
    color: #ffffff;
    box-shadow: 0 8px 20px rgba(21, 158, 114, 0.28);

    &:hover {
      box-shadow: 0 12px 28px rgba(21, 158, 114, 0.38);
    }
  }

  &--outline {
    background: #ffffff;
    color: $navy;
    border-color: rgba(12, 36, 97, 0.18);

    &:hover {
      border-color: $navy;
    }
  }

  &--ghost {
    background: transparent;
    color: $navy;

    &:hover {
      background: rgba(12, 36, 97, 0.06);
    }
  }

  &--light {
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.35);

    &:hover {
      background: #ffffff;
      color: $navy;
    }
  }
}

/* NAV */
.lp-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(14px) saturate(160%);
  border-bottom: 1px solid transparent;
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;

  &--scrolled {
    background: rgba(255, 255, 255, 0.94);
    border-bottom-color: $line;
    box-shadow: 0 6px 24px rgba(15, 23, 42, 0.05);
  }
}

.lp-nav__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

.lp-nav__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.lp-nav__logo {
  height: 60px;
  width: auto;
}

.lp-nav__links {
  display: flex;
  align-items: center;
  gap: 26px;
}

.lp-nav__link {
  position: relative;
  font-weight: 600;
  font-size: 14px;
  color: $muted;
  text-decoration: none;
  transition: color 0.2s ease;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -6px;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    background: $green;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.25s ease;
  }

  &:hover {
    color: $navy;

    &::after {
      transform: scaleX(1);
    }
  }
}

.lp-nav__toggle {
  display: none;
  font-weight: 700;
  font-size: 14px;
  color: $navy;
  background: #ffffff;
  border: 1px solid $line;
  border-radius: 10px;
  padding: 8px 14px;
  cursor: pointer;
}

.lp-nav__mobile {
  display: none;
  flex-direction: column;
  gap: 10px;
  padding: 12px 20px 20px;
  background: #ffffff;
  border-top: 1px solid $line;
}

.lp-nav__mobile-link {
  font-weight: 600;
  color: $ink;
  text-decoration: none;
  padding: 10px 0;
  border-bottom: 1px solid $line;
}

.lp-drop-enter-active,
.lp-drop-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.lp-drop-enter,
.lp-drop-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* HERO */
.lp-hero {
  position: relative;
  overflow: hidden;
  padding: 96px 0 112px;
  background: linear-gradient(180deg, #f3fbf8 0%, #ffffff 70%);
}

.lp-hero__glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;

  &--green {
    width: 520px;
    height: 520px;
    top: -180px;
    right: -120px;
    background: rgba(21, 158, 114, 0.22);
  }

  &--navy {
    width: 420px;
    height: 420px;
    bottom: -220px;
    left: -160px;
    background: rgba(12, 36, 97, 0.12);
  }
}

.lp-hero__grid-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: linear-gradient(rgba(12, 36, 97, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(12, 36, 97, 0.05) 1px, transparent 1px);
  background-size: 48px 48px;
  -webkit-mask-image: radial-gradient(ellipse at 70% 30%, #000 0%, transparent 65%);
  mask-image: radial-gradient(ellipse at 70% 30%, #000 0%, transparent 65%);
}

.lp-hero__grid {
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  gap: 72px;
  align-items: center;
}

.lp-pill {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 700;
  color: $navy;
  background: #ffffff;
  border: 1px solid rgba(21, 158, 114, 0.25);
  border-radius: 999px;
  padding: 7px 14px;
  margin-bottom: 22px;
  box-shadow: 0 4px 14px rgba(21, 158, 114, 0.1);
}

.lp-pill__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: $green;
  animation: lp-pulse 1.8s ease-out infinite;
}

.lp-hero__title {
  font-size: 52px;
  line-height: 1.08;
  font-weight: 900;
  color: $navy;
  letter-spacing: -1.5px;
  margin-bottom: 22px;
}

.lp-hero__text {
  font-size: 17px;
  line-height: 1.75;
  color: $muted;
  max-width: 540px;
  margin-bottom: 34px;
}

.lp-hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.lp-hero__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 28px;
  font-size: 13px;
  font-weight: 600;
  color: $muted;
}

.lp-hero__sep {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(71, 85, 105, 0.4);
}

.lp-hero__visual {
  position: relative;
}

/* APERÇU */
.lp-preview {
  position: relative;
  z-index: 1;
  background: #ffffff;
  border: 1px solid $line;
  border-radius: 18px;
  box-shadow: 0 30px 60px -12px rgba(12, 36, 97, 0.18), 0 12px 24px -8px rgba(12, 36, 97, 0.08);
  overflow: hidden;
}

.lp-preview__bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 16px;
  background: $soft;
  border-bottom: 1px solid $line;

  > span {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: rgba(15, 23, 42, 0.12);
  }
}

.lp-preview__url {
  margin-left: 12px;
  flex: 1;
  font-size: 11px;
  font-weight: 600;
  color: $muted;
  background: #ffffff;
  border: 1px solid $line;
  border-radius: 6px;
  padding: 4px 10px;
}

.lp-preview__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
}

.lp-preview__label {
  font-size: 12px;
  font-weight: 600;
  color: $muted;
}

.lp-preview__title {
  font-size: 17px;
  font-weight: 800;
  color: $navy;
}

.lp-preview__tag {
  font-size: 12px;
  font-weight: 700;
  color: $green;
  background: rgba(21, 158, 114, 0.1);
  padding: 5px 11px;
  border-radius: 999px;
}

.lp-preview__row {
  display: grid;
  grid-template-columns: 2fr 0.7fr 1.2fr 0.8fr;
  align-items: center;
  gap: 10px;
  padding: 13px 24px;
  font-size: 14px;
  color: $muted;
  border-top: 1px solid $line;
  transition: background 0.2s ease;

  &:not(.lp-preview__row--head):hover {
    background: rgba(21, 158, 114, 0.04);
  }

  &--head {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    background: $soft;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

.lp-preview__trajet {
  font-weight: 700;
  color: $ink;
}

.lp-preview__fill {
  display: flex;
  align-items: center;
  gap: 8px;
}

.lp-preview__track {
  flex: 1;
  height: 6px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.07);
  overflow: hidden;
}

.lp-preview__bar-fill {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, $green, $teal);
}

.lp-preview__pct {
  font-size: 12px;
  font-weight: 700;
  color: $ink;
  min-width: 30px;
}

.lp-preview__prix {
  font-weight: 800;
  color: $navy;
}

.lp-preview__foot {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 20px 24px;
  background: linear-gradient(135deg, $navy 0%, $navy-deep 100%);
  color: #ffffff;
}

.lp-preview__stat {
  font-size: 21px;
  font-weight: 800;
}

.lp-preview__stat-label {
  font-size: 12px;
  opacity: 0.7;
}

/* CARTES FLOTTANTES */
.lp-float {
  position: absolute;
  z-index: 2;
  background: #ffffff;
  border: 1px solid $line;
  border-radius: 14px;
  padding: 12px 16px;
  box-shadow: 0 18px 36px -10px rgba(12, 36, 97, 0.25);
  animation: lp-float 5s ease-in-out infinite;

  &--top {
    top: -26px;
    left: -36px;
    border-left: 4px solid $green;
  }

  &--bottom {
    bottom: -28px;
    right: -24px;
    border-left: 4px solid $navy;
    animation-delay: 1.5s;
  }
}

.lp-float__label {
  font-size: 11px;
  font-weight: 600;
  color: $muted;
}

.lp-float__value {
  font-size: 14px;
  font-weight: 800;
  color: $navy;

  &--green {
    color: $green;
  }
}

/* BANDEAU */
.lp-strip {
  background: $navy;
  padding: 36px 0;
}

.lp-strip__inner {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.lp-strip__item {
  padding-left: 18px;
  border-left: 2px solid rgba(21, 158, 114, 0.6);
}

.lp-strip__value {
  font-size: 18px;
  font-weight: 800;
  color: #ffffff;
}

.lp-strip__label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
  margin-top: 2px;
}

/* SECTIONS */
.lp-section {
  padding: 104px 0;

  &--alt {
    background: $soft;
  }
}

.lp-section__head {
  max-width: 640px;
  margin-bottom: 52px;

  &--center {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
}

.lp-section__title {
  font-size: 38px;
  line-height: 1.15;
  font-weight: 900;
  color: $navy;
  letter-spacing: -0.8px;
  margin-bottom: 14px;
}

.lp-section__text {
  font-size: 16px;
  line-height: 1.7;
  color: $muted;
  margin: 0;
}

/* FONCTIONNALITÉS */
.lp-features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.lp-feature {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid $line;
  border-radius: 16px;
  padding: 32px 28px;
  transition: opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1), transform 0.7s cubic-bezier(0.22, 1, 0.36, 1),
    border-color 0.25s ease, box-shadow 0.25s ease;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, $green, $teal);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.35s ease;
  }

  &.is-visible:hover {
    transform: translateY(-4px);
    border-color: rgba(21, 158, 114, 0.3);
    box-shadow: 0 20px 40px -16px rgba(12, 36, 97, 0.2);

    &::before {
      transform: scaleX(1);
    }
  }
}

.lp-feature__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 900;
  color: $green;
  background: rgba(21, 158, 114, 0.1);
  margin-bottom: 20px;
  transition: background 0.25s ease, color 0.25s ease;
}

.lp-feature:hover .lp-feature__num {
  background: $green;
  color: #ffffff;
}

.lp-feature__title {
  font-size: 18px;
  font-weight: 800;
  color: $navy;
  margin-bottom: 8px;
}

.lp-feature__text {
  font-size: 15px;
  line-height: 1.65;
  color: $muted;
  margin: 0;
}

/* ÉTAPES */
.lp-steps {
  position: relative;
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;

  &::before {
    content: "";
    position: absolute;
    top: 28px;
    left: 16%;
    right: 16%;
    border-top: 2px dashed rgba(21, 158, 114, 0.35);
  }
}

.lp-step {
  position: relative;
  text-align: center;
  padding: 0 12px;
}

.lp-step__num {
  position: relative;
  z-index: 1;
  width: 56px;
  height: 56px;
  margin: 0 auto 22px;
  border-radius: 50%;
  background: linear-gradient(135deg, $green, $teal);
  color: #ffffff;
  font-size: 20px;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 8px $soft, 0 10px 24px rgba(21, 158, 114, 0.35);
}

.lp-step__title {
  font-size: 18px;
  font-weight: 800;
  color: $navy;
  margin-bottom: 8px;
}

.lp-step__text {
  font-size: 15px;
  line-height: 1.65;
  color: $muted;
  max-width: 300px;
  margin: 0 auto;
}

/* CTA */
.lp-cta-wrap {
  padding: 96px 0;
}

.lp-cta {
  position: relative;
  overflow: hidden;
  border-radius: 24px;
  padding: 56px;
  background: radial-gradient(circle at 85% 20%, rgba(21, 158, 114, 0.45) 0%, transparent 45%),
    linear-gradient(135deg, $navy 0%, $navy-deep 100%);
}

.lp-cta__ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  pointer-events: none;

  &--1 {
    width: 340px;
    height: 340px;
    top: -140px;
    right: -60px;
  }

  &--2 {
    width: 520px;
    height: 520px;
    top: -230px;
    right: -150px;
  }
}

.lp-cta__inner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
}

.lp-cta__title {
  font-size: 32px;
  font-weight: 900;
  color: #ffffff;
  letter-spacing: -0.5px;
  margin-bottom: 10px;
}

.lp-cta__text {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.75);
  margin: 0;

  a {
    color: #ffffff;
    font-weight: 700;
    text-decoration-color: rgba(21, 158, 114, 0.8);
    text-underline-offset: 3px;
  }
}

.lp-cta__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

/* FOOTER */
.lp-footer {
  background: $navy-deep;
  color: rgba(255, 255, 255, 0.7);
  padding: 64px 0 28px;
}

.lp-footer__top {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr;
  gap: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.lp-footer__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 900;
  color: #ffffff;
}

.lp-footer__desc {
  font-size: 14px;
  line-height: 1.7;
  max-width: 300px;
  margin: 14px 0 20px;
}

.lp-store {
  display: inline-flex;
  flex-direction: column;
  padding: 9px 18px;
  border-radius: 10px;
  background: #000000;
  border: 1px solid rgba(255, 255, 255, 0.25);
  text-decoration: none;
  cursor: default;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.5);
  }
}

.lp-store__small {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.75);
}

.lp-store__name {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.2;
}

.lp-footer__col {
  display: flex;
  flex-direction: column;
  gap: 12px;

  a {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #ffffff;
    }
  }
}

.lp-footer__title {
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #ffffff;
  margin-bottom: 4px;
}

.lp-footer__bottom {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding-top: 24px;
  font-size: 13px;
}

/* RESPONSIVE */
@media (max-width: 960px) {
  .lp-nav__links {
    display: none;
  }

  .lp-nav__toggle {
    display: block;
  }

  .lp-nav__mobile {
    display: flex;
  }

  .lp-hero {
    padding: 56px 0 80px;
  }

  .lp-hero__grid {
    grid-template-columns: 1fr;
    gap: 56px;
  }

  .lp-hero__title {
    font-size: 38px;
  }

  .lp-float--top {
    left: 12px;
  }

  .lp-float--bottom {
    right: 12px;
  }

  .lp-strip__inner {
    grid-template-columns: repeat(2, 1fr);
  }

  .lp-features {
    grid-template-columns: repeat(2, 1fr);
  }

  .lp-steps {
    grid-template-columns: 1fr;
    gap: 40px;

    &::before {
      display: none;
    }
  }

  .lp-cta {
    padding: 40px 32px;
  }

  .lp-cta__inner {
    flex-direction: column;
    align-items: flex-start;
  }

  .lp-footer__top {
    grid-template-columns: 1fr 1fr;
  }

  .lp-footer__about {
    grid-column: 1 / -1;
  }
}

@media (max-width: 600px) {
  .lp-container {
    padding: 0 16px;
  }

  .lp-hero__title {
    font-size: 31px;
    letter-spacing: -1px;
  }

  .lp-section,
  .lp-cta-wrap {
    padding: 64px 0;
  }

  .lp-section__title {
    font-size: 27px;
  }

  .lp-features {
    grid-template-columns: 1fr;
  }

  .lp-strip__inner {
    grid-template-columns: 1fr;
  }

  .lp-preview__row {
    grid-template-columns: 1.6fr 0.7fr 0.8fr;
    padding: 12px 16px;

    > span:nth-child(3) {
      display: none;
    }
  }

  .lp-preview__head,
  .lp-preview__foot {
    padding: 16px;
  }

  .lp-float {
    display: none;
  }

  .lp-cta {
    padding: 32px 20px;
    border-radius: 18px;
  }

  .lp-cta__title {
    font-size: 26px;
  }

  .lp-hero__actions .lp-btn,
  .lp-cta__actions .lp-btn {
    width: 100%;
  }

  .lp-footer__top {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  .lp-anim,
  .lp-reveal {
    opacity: 1;
    transform: none;
    animation: none;
    transition: none;
  }

  .lp-float,
  .lp-pill__dot {
    animation: none;
  }
}
</style>
